import { concat } from '@ember/helper';
import { trustHTML } from '@ember/template';
import Component from '@glimmer/component';
import { or } from 'ember-truth-helpers';

import type { TooltipOptions } from '../../../../types/components/prism/data-bar.ts';
import {
  COLOR_TEXT_DEFAULT,
  getCssVariableValue,
} from '../../../../utils/css-variable.ts';
import PrismIcon from '../../icon.gts';
import PrismTooltip from '../../tooltip.gts';
import styles from '../data-bar-label-value-target.module.css';

interface PrismDataBarBlocksDataBarValueSignature {
  Args: {
    color?: string;
    showBottomValues?: boolean;
    text?: string;
    tooltip?: TooltipOptions;
    valueItems?: {
      isHidden: boolean;
      style: string;
      widthPercentage?: number;
    }[];
  };
  Blocks: {
    default: [];
  };
}

export default class PrismDataBarBlocksDataBarValue extends Component<PrismDataBarBlocksDataBarValueSignature> {
  get styleForColor(): string {
    const color = this.args.color ?? getCssVariableValue(COLOR_TEXT_DEFAULT);

    return `color: ${color}`;
  }

  <template>
    {{#if (has-block)}}
      <div class={{unless @showBottomValues styles.value-top}}>
        {{yield}}
      </div>
    {{else if @showBottomValues}}
      <div class={{styles.value-bottom}}>
        {{#each @valueItems as |valueItem|}}
          <p class={{styles.data-bar-bottom}} style={{valueItem.style}}>
            {{#unless valueItem.isHidden}}
              {{concat valueItem.widthPercentage "%"}}
            {{/unless}}
          </p>
        {{/each}}
      </div>
    {{else}}
      <div
        class={{styles.data-bar-normal}}
        style={{trustHTML this.styleForColor}}
      >
        {{@text}}

        {{#if @tooltip.message}}
          <div>
            <PrismIcon
              @color={{@tooltip.color}}
              @name={{or @tooltip.icon "circle-information-outline"}}
              @size={{or @tooltip.iconSize "small"}}
            />
            <PrismTooltip
              @side={{@tooltip.side}}
              @text={{@tooltip.message}}
              @title={{@tooltip.title}}
            />
          </div>
        {{/if}}
      </div>
    {{/if}}
  </template>
}
